<template>
    <div class="sound" :class="{'hidden':$route.name === 'oelteltet'}">
        <CircleWrap @click.native="playSound('univers', true, 0.2, false)" :class="{'muted': sound === false}">
            <VolumeOn v-if="sound === true"/>
            <VolumeOff v-else/>
        </CircleWrap>
    </div>
</template>

<script>
	import CircleWrap from "@/components/CircleWrap";
	import VolumeOn from "@/assets/icons/volume-on.svg"
	import VolumeOff from "@/assets/icons/volume-off.svg"
	import {mapState} from "vuex";
	export default {
		name: "Sound",
		components: {
			CircleWrap,
			VolumeOn,
			VolumeOff
		},
        data(){
		    return{
		    	hasPlayed: false,
		    	sound: false,
                sounds: {
		    		univers: false,
                    horse: false,
                    info: false
                }
            }
        },
        watch: {
			$route(to,from){
                if(to.name === 'markedsinfo' && from.name === 'univers')
                {
	                this.playSound('info', false, 1, true)
                }
                else if(to.name === 'oelteltet')
                {
                	if(this.sound !== false)
                	{
		                this.sound = false;
		                this.sounds.univers.pause();
	                }
	                
                }
            },
			notification(to,from){
				if(to !== ''){
					this.playSound('info', false, 1, true)
                }
            },
            unreadMessages(to,from){
				if(to > 0 && this.currentRoom === false){
					this.playSound('horse', false, 1, true)
                }
            }
        },
        mounted(){
			let that = this
			this.sounds.univers = new Audio(require('@/assets/sounds/people.mp3'))
	        this.sounds.horse = new Audio(require('@/assets/sounds/horse.mp3'))
	        this.sounds.info = new Audio(require('@/assets/sounds/info.mp3'))
        },
		computed: {
			...mapState('vorbasse', {
				notification: state => state.notification,
                rooms: state => state.rooms,
				currentRoom: state => state.currentRoom
			}),
			unreadMessages(){
				let count = 0;
				Object.keys(this.rooms).forEach(room => {
					count += Number(this.rooms[room].unreadMessages);
				})
				return count;
			}
		},
        methods: {
			playSound(type,loop,volume,force){

				if(this.hasPlayed === false){
					// Unlock?
					this.hasPlayed = true
					this.sounds.univers.volume = 0
					this.sounds.univers.play()
					this.sounds.univers.pause()
					this.sounds.univers.currentTime = 0;
					this.sounds.horse.volume = 0
					this.sounds.horse.play()
					this.sounds.horse.pause()
					this.sounds.horse.currentTime = 0;
					this.sounds.info.volume = 0
					this.sounds.info.play()
					this.sounds.info.pause()
					this.sounds.info.currentTime = 0;
                }

				let audio = this.sounds[type]
				if(this.sound === false || force === true){
					if(!force){this.sound = true}
                    if(loop){audio.loop = loop}else{audio.currentTime = 0}
                    audio.volume = volume
                    audio.play()
                }else{
					this.sound = false
					audio.pause()
                }
            }
        }
	}
</script>

<style lang="scss" scoped>
	.sound{
		&.hidden{
			display: none;
		}
	}
    .circle{
        position: fixed;
        bottom: 15px;
        left: 15px;
        z-index: 2;
        text-align: center;
        line-height: 60px;
        background: rgba(0,0,0,0.5);
        cursor: pointer;
        &.muted{
            opacity: 0.5;
        }
    }
</style>
